<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div class="text item">
        <div class="mt-stock-top flex-row-align">
          <el-button @click="stockOpenBtn(1)" size="small" type="primary" class="bg-theme">增加库存</el-button>
          <el-button @click="stockOpenBtn(2)" size="small" type="primary" class="bg-theme">减少库存</el-button>
        </div>
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cardName"
            label="礼品卡名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="changeType"
            label="变化类型">
            <template slot-scope="scope">
              <span v-if="scope.row.changeType === 1">增加</span>
              <span v-else>减少</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="changeNumber"
            label="变化数量">
          </el-table-column>
          <el-table-column
            align="center"
            prop="stockType"
            label="库存类型">
            <template slot-scope="scope">
              <span v-if="scope.row.stockType === 1">手动增加</span>
              <span v-else-if="scope.row.stockType === 2">手动减少</span>
              <span v-else-if="scope.row.stockType === 3">卡组生成</span>
              <span v-else>购买减少</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateTime"
            label="变动时间">
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 增加库存弹窗 -->
    <el-dialog
      :title="stockType == 1 ? '增加库存' : '减少库存'"
      :visible.sync="stockShow"
      width="960px">
      <el-form :model="stockForm" label-width="140px">
        <el-form-item label="当前库存：">
          <span>{{allNum}}</span>
        </el-form-item>
        <el-form-item :label="stockType == 1 ? '增加库存：' : '减少库存：'">
          <el-input style="width: 420px;" v-model="stockForm.num" :placeholder="stockType == 1 ? '请输入要增加库存数量' : '请输入要减少库存数量'"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="stockSaveBtn">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { queryGiftCardStockLogPageList, queryGifCardStockNumber, addGiftCardStock, subtractGiftCardStock } from '@/api/giftCard'
export default {
  name: 'StockRecord',
  data () {
    return {
      imgServer: this.$imgServer,
      dataId: this.$route.query.dataId,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      // 增加库存弹窗
      stockShow:false,
      // stockType 1增加 2减少
      stockType:1,
      stockForm:{
        num:''
      },
      allNum:''
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 增加库存弹窗-打开操作
    stockOpenBtn(type){
      var that = this;
      that.stockType = type;
      var dataId = that.dataId;
      queryGifCardStockNumber({cardId:dataId}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.allNum = data.stockNum;
          that.stockShow = true;
        }
      })
    },
    // 增加库存弹窗-保存操作
    stockSaveBtn(){
      var stockType = this.stockType;
      var dataId = this.dataId;
      var changeNumber = this.stockForm.num;
      if(changeNumber == ''){
        this.$message.error(stockType == 1 ? '请输入要增加库存数量' : '请输入要减少库存数量')
        return false
      }
      console.log(changeNumber,'changeNumber')
      var that = this;
      var passData = {
        cardId:dataId,
        changeNumber:changeNumber
      }
      if(stockType == 1){
        // 增加
        addGiftCardStock(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        // 减少
        subtractGiftCardStock(passData).then((res) => {
          that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.stockShow = false;
            that.getInfoList();
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let cardId = that.dataId
      let page = that.currentPage
      queryGiftCardStockLogPageList({ cardId: cardId, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/giftCard/StockRecord.vue